module.exports = __webpack_public_path__ + "img/double_pad.7dfc59ab.jpg";